<template>
  <div :id="componentId">
    <b-row>
      <b-colxx xxl="10" xl="10" lg="10" class="px-0">
        <span class="y-axis-label">Participants</span>
        <div class="study-completion-table">
          <div class="rtl-display">
            <div class="completion-table table-content" ref="test" v-on:scroll="onScrollTable" :style="{ maxHeight: height }">
              <transition name="fade">
                <div v-if="showTableContainer" class="completion-table">
                  <table v-if="newData != null" class="mt-10 ltr-display">
                    <!-- Participant rows -->
                    <tbody id="table-body-boxes" class="table-body-boxes">
                      <tr :id="snakeCasess(generateParticipantsId(r.participants))" v-for="r in newData" :key="generateParticipantsId(r.participants)" class="w-auto">
                        <div class="d-flex justify-content-between">
                          <div>
                            <!-- Participant name column -->
                            <th class="body-participant-column">
                              <div class="add-tooltip study-completion-xaxis text-truncate d-inline-block">
                                {{ generateParticipantsId(r.participants) }}
                              </div>
                              <div class="custom-tooltip hidden-text-custom m-0">
                                {{ generateParticipantsId(r.participants) }}
                              </div>
                            </th>
                            <!-- Completion boxes matrix -->
                            <td class="completion-boxes-td" v-for="(c, i) in r.matrixActivities" :key="i" :id="snakeCasess(generateParticipantsId(r.participants) + c.activityName)">
                              <div class="completion-boxes-div">
                                <!-- Status box -->
                                <div
                                  :class="c.classLabel + ' study-completion-tooltip completion-item-anim' + (!activeLegend.includes(c.status) && ' study-completion-inactive')"
                                  @mouseover="c.status !== 'Not Scheduled' && showingTooltips(c, generateParticipantsId(r.participants), r.participants && r.participants.isThreadID, snakeCasess(generateParticipantsId(r.participants) + c.activityName), $event)"
                                  @mouseout="closedTooltip(snakeCasess(generateParticipantsId(r.participants) + c.activityName))"
                                  :style="'background-color:' + setBgHeatmaps(c.status) + ';'"
                                ></div>
                              </div>
                            </td>
                          </div>
                          <div class="completion-percentage-div">
                            <!-- Completion percentage column -->
                            <td class="completion-percentage-td">
                              <div class="">
                                <span class="study-completion-percent">{{ Math.round(r.totalPercentageCompleted) }}%</span>
                              </div>
                            </td>
                          </div>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                  <span id="completion1-tooltips"></span>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <span class="x-axis-label">Activities</span>
      </b-colxx>
      <div class="d-flex flex-column justify-content-center p-0">
        <div class="mb-2 ">
          <span
            id="Complete"
            @click="handleLegend('Completed')"
            :class="{
              'study-completion-inactive': !activeLegend.includes('Completed')
            }"
            class="study-completion-legend-complete study-completion-tooltip"
          >
            <div class="study-completion-tooltiptext px-1 d-flex flex-column study-completion-tooltip-complete remove-elem-download" :style="'background-color:' + setBgHeatmaps('Completed') + ';' + 'color:' + getContrastTextColor(setBgHeatmaps('Completed')) + ';'">
              <span>Participants: {{ total.completed }}</span>
              <span>Activities: {{ totalActivity.completed }}</span>
            </div>
          </span>
          <span class="study-completion-legend-text">Completed</span>
        </div>
        <div class="mb-2 ">
          <span
            id="NotComplete"
            @click="handleLegend('NotComplete')"
            :class="{
              'study-completion-inactive': !activeLegend.includes('NotComplete')
            }"
            class="study-completion-legend-incomplete study-completion-tooltip"
          >
            <div class="study-completion-tooltiptext px-1 d-flex flex-column study-completion-tooltip-incomplete remove-elem-download">
              <span>Participants: {{ total.notCompleted }}</span>
              <span>Activities: {{ totalActivity.notCompleted }}</span>
            </div>
          </span>
          <span class="study-completion-legend-text">Not Completed</span>
        </div>
        <div class="mb-2 ">
          <span
            id="Ongoing"
            @click="handleLegend('Ongoing')"
            :class="{
              'study-completion-inactive': !activeLegend.includes('Ongoing')
            }"
            class="study-completion-legend-ongoing study-completion-tooltip"
          >
            <div class="study-completion-tooltiptext px-1 d-flex flex-column study-completion-tooltip-ongoing remove-elem-download">
              <span>Participants: {{ total.onGoing }}</span>
              <span>Activities: {{ totalActivity.onGoing }}</span>
            </div>
          </span>
          <span class="study-completion-legend-text">On Going</span>
        </div>
        <div class="mb-2 ">
          <span
            id="Upcoming"
            @click="handleLegend('Upcoming')"
            :class="{
              'study-completion-inactive': !activeLegend.includes('Upcoming')
            }"
            class="study-completion-legend-upcoming study-completion-tooltip"
          >
            <div class="study-completion-tooltiptext px-1 d-flex flex-column study-completion-tooltip-upcoming remove-elem-download">
              <span>Participants: {{ total.upcoming }}</span>
              <span>Activities: {{ totalActivity.upcoming }}</span>
            </div>
          </span>
          <span class="study-completion-legend-text">Upcoming</span>
        </div>
        <div class="mb-2 ">
          <span
            id="NotScheduled"
            @click="handleLegend('Not Scheduled')"
            :class="{
              'study-completion-inactive': !activeLegend.includes('Not Scheduled')
            }"
            class="study-completion-legend-notscheduled study-completion-tooltip"
          >
          </span>
          <span class="study-completion-legend-text">No Activity Scheduled</span>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { getPrimaryColorFunc, getContrastTextColor, generateParticipantId } from "../../services/visualization/utils";
import _ from "lodash";

export default {
  props: {
    matrixData: [Array, null],
    height: String,
    total: {
      type: Object
    },
    totalActivity: {
      type: Object
    },
    msg: String,
    limit: { type: Number, default: 10 },
    page: { type: Number, default: 1 }
  },
  data() {
    return {
      componentId: "study-completion-chart",
      newData: [],
      tableData: null,
      tableItemSize: 0,
      showTableContainer: false,
      activeLegend: ["Completed", "NotComplete", "Upcoming", "Ongoing", "Not Scheduled"],
      rowWidth: "",
      getContrastTextColor: getContrastTextColor,
      tempLimit: this.limit,
      prevVerticalScroll: 0,
      prevHorizontalScroll: 0
    };
  },
  watch: {
    matrixData: {
      deep: true,
      handler(value) {
        this.newData = value;
        this.render();
      }
    }
  },
  methods: {
    handleLegend(status) {
      const tempArr = [];
      if (this.activeLegend.length === 1 && this.activeLegend[0] === status) {
        tempArr.push("Completed", "NotComplete", "Upcoming", "Ongoing", "Not Scheduled");
      } else {
        tempArr.push(status);
      }
      this.activeLegend = tempArr;
    },
    onScrollTable() {
      const verticalScrollPosition = this.$refs.test.clientHeight + this.$refs.test.scrollTop;
      if (this.$refs.test.scrollTop !== 0 && verticalScrollPosition > this.$refs.test.scrollHeight - 1 && verticalScrollPosition > this.prevVerticalScroll) {
        this.prevVerticalScroll = verticalScrollPosition;
        this.$emit("onScrollTable", "vertical");
        this.$refs.test.scrollTop = this.$refs.test.scrollHeight - this.$refs.test.clientHeight;
      }

      const horizontalScrollPosition = this.$refs.test.scrollWidth - (Math.abs(this.$refs.test.scrollLeft) + this.$refs.test.clientWidth);
      const horizontalScrollBoundary = this.$refs.test.scrollWidth - this.$refs.test.clientWidth - 1;
      if (horizontalScrollPosition !== 0 && horizontalScrollPosition >= horizontalScrollBoundary && horizontalScrollPosition > this.prevHorizontalScroll) {
        this.prevHorizontalScroll = horizontalScrollPosition;
        this.$emit("onScrollTable", "horizontal");
      }
    },
    render() {
      const vis = this.newData;
      // // Reset state
      this.showTableContainer = false;
      let maxStep = 0;
      for (const a in vis) {
        const checkMax = vis[a].matrixActivities.length;
        if (checkMax > maxStep) {
          maxStep = checkMax;
        }
      }
      // 10% id for header, 10% for participant percentage, rest 70% is actual matrix map
      this.tableItemSize = 70 / maxStep;

      setTimeout(() => {
        this.showTableContainer = true;
        // Then animate percents
        setTimeout(() => {
          document.querySelector(".completion-table").scrollLeft -= document.querySelector(".completion-table").offsetWidth;
        }, 100);
      }, 100);
    },
    snakeCasess(text) {
      return _.snakeCase(text);
    },
    generateParticipantsId(participant) {
      return generateParticipantId(participant);
    },

    showingTooltips(data, participantId, isThreadID, elementId, event) {
      let element = null;
      let tableElement = null;
      let tooltips = null;
      let status = data.status;
      if (data.status == "NotComplete") {
        status = "Not Completed";
      } else if (data.status == "Ongoing") {
        status = "On Going";
      }

      const hexColors = this.setColor(data.status, data.statusTooltip);

      tableElement = document.getElementById("table-body-boxes");
      if (elementId) {
        element = document.getElementById(elementId);
      }

      tooltips = document.getElementById("completion1-tooltips");

      const completion1ElementTooltips = element.getBoundingClientRect();
      const completion1Table = tableElement.getBoundingClientRect();

      if (completion1Table.y > completion1ElementTooltips.y) {
        tooltips.style.bottom = completion1ElementTooltips.top + 25 + "px";
      } else {
        tooltips.style.top = completion1ElementTooltips.top + 25 + "px";
      }

      tooltips.style.left = event.x + "px";
      tooltips.style.position = "fixed";
      tooltips.style.visibility = "visible";
      tooltips.style.borderRadius = "4px";
      // tooltips.style.top = completion1ElementTooltips.top + "px"
      tooltips.style.backgroundColor = hexColors;
      tooltips.style.color = getContrastTextColor(hexColors);
      tooltips.style.zIndex = 100000000000000;
      tooltips.style.padding = "5px";
      tooltips.style.fontSize = "10px";
      tooltips.style.cursor = "pointer";
      tooltips.style.pointerEvents = "none";

      //   tooltips.addEventListener("mouseenter", function() {
      //     tooltips.style.visibility = "visible"
      //   })

      tooltips.innerHTML = `
        <span>${isThreadID ? "PID" : "TID"}: ${participantId}</span><br/>
        <span>Activity: ${data.activityName}</span><br/>
        <span>Day: ${data.scheduledDays}</span><br/>
        <span>Status: ${status} ${data.activityProgress}</span>
      `;
    },
    setColor(status = "", classlabel = "") {
      let tmpColor = "";
      switch (classlabel) {
        case "study-completion-tooltip-complete":
          tmpColor = "#987efe";
          break;
        case "study-completion-tooltip-upcoming":
          tmpColor = "#d9d9d9";
          break;
        case "study-completion-tooltip-ongoing":
          tmpColor = "#ffe585";
          break;
        case "study-completion-tooltip-incomplete":
          tmpColor = "#ffb9b8";
          break;
        case "study-completion-tooltip-notscheduled":
          tmpColor = "#ffffff";
          break;
        default:
          break;
      }

      return status === "Completed" ? this.shadeColor(getPrimaryColorFunc(), 10) : tmpColor;
    },
    shadeColor(color, percent) {
      let R = parseInt(color.substring(1, 3), 16);
      let G = parseInt(color.substring(3, 5), 16);
      let B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      const RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      const GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      const BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    setPercentagePrimaryColor() {
      return getPrimaryColorFunc();
    },
    setBgHeatmaps(status = "") {
      return status === "Completed" ? getPrimaryColorFunc() : "";
    },
    closedTooltip() {
      const tooltips = document.getElementById("completion1-tooltips");
      tooltips.style.visibility = "hidden";
    }
  },
  async mounted() {
    this.newData = this.matrixData;
    this.render();
  }
};
</script>

<style scoped>
.rotate {
  /* FF3.5+ */
  -moz-transform: rotate(90deg);
  /* Opera 10.5 */
  -o-transform: rotate(90deg);
  /* Saf3.1+, Chrome */
  -webkit-transform: rotate(90deg);
  /* IE6,IE7 */
  filter: progid: DXImageTransform.Microsoft.BasicImage(rotation=0.083);
  /* IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0.083)";
  /* Standard */
  transform: rotate(90deg);
}

.study-completion-tooltip {
  border-bottom: transparent;
  z-index: 1;
}

.study-completion-tooltip .study-completion-tooltiptext {
  visibility: hidden;
  width: 80px;
  color: #000;
  text-align: left;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 9999;
  bottom: 150%;
  margin-left: -30px;
  font-size: 9px;
}

.study-completion-tooltip .study-completion-box-tooltiptext {
  visibility: hidden;
  width: 200px;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 9999;
  bottom: 110%;
  margin-left: -35px;
  font-size: 9px;
}

.study-completion-tooltip:hover .study-completion-tooltiptext {
  visibility: visible;
}

.study-completion-tooltip:hover .study-completion-box-tooltiptext {
  visibility: visible;
}

.study-completion-tooltip-complete {
  background-color: var(--study-primary-color);
}

.study-completion-tooltip-upcoming {
  background-color: #bdbcbc;
}

.study-completion-tooltip-ongoing {
  background-color: #fdbf6f;
}

.study-completion-tooltip-incomplete {
  background-color: #fb9a99;
}

.study-completion-tooltip-notscheduled {
  background-color: #ffffff;
}

.study-completion-box-notscheduled {
  height: 100%;
  width: 100%;
  background-color: #d3d3d3;
}

.study-completion-legend-upcoming {
  background-color: #a9a9a9;
}

.study-completion-legend-notscheduled {
  background-color: #d3d3d3;
  float: left;
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  margin-right: 6px;
}

.study-completion-box-upcoming {
  background-color: #a9a9a9;
}

.study-completion-tooltip-complete::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--study-primary-color) transparent transparent transparent;
}

.study-completion-tooltip-upcoming::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #d9d9d9 transparent transparent transparent;
}

.study-completion-tooltip-notscheduled::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ffffff transparent transparent transparent;
}

.study-completion-tooltip-ongoing::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fdbf6f transparent transparent transparent;
}

.study-completion-tooltip-incomplete::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fb9a99 transparent transparent transparent;
}

.study-completion-xaxis {
  height: 12px !important;
}

.custom-tooltip:after {
  content: " ";
  position: unset;
  top: 0;
  right: 0;
  margin-top: 0;
  border-width: 0;
  border-style: unset;
  border: none;
  border-right-color: unset;
  left: 0;
}

.custom-tooltip:before {
  content: " ";
  position: unset;
  top: 0;
  right: 0;
  margin-top: 0;
  border: none;
  border-right-color: unset;
  left: 0;
}

.custom-tooltip {
  left: 2.5rem;
  top: -2px;
  width: max-content;
}
.study-completion-percent {
  margin: 0;
  margin-left: 2px;
  color: var(--study-primary-color);
}
.y-axis-label {
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  position: absolute;
  top: 50%;
  color: #959fa4;
  font-size: 10px;
}

.x-axis-label {
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  left: 50%;
  bottom: -30px;
  font-size: 10px;
  color: #959fa4;
}

.rtl-display {
  width: 100%;
  display: block;
  direction: rtl;
}

.ltr-display {
  width: 100%;
  direction: ltr;
}

.table-content {
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
  height: max-content;
}

.table-body-boxes {
  width: 100%;
  padding-bottom: 1px;
  padding-top: 1px;
}

.body-participant-column {
  position: sticky;
  left: 0;
  width: 5%;
  padding-left: 5px;
  height: 28px;
  background-color: white;
}

.w-auto {
  width: auto;
}

.completion-boxes-td {
  padding: 0;
  padding-left: 5px;
  width: 1px;
  overflow: hidden;
}

.completion-boxes-div {
  height: 25px;
  width: 40px;
}

.completion-percentage-div {
  position: sticky;
  right: 0;
}

.completion-percentage-td {
  height: 28px;
  width: 40px;
  min-width: 40px;
  background-color: white;
  text-align: left;
  padding-left: 10px;
}
.completion-item-anim:hover {
  border: none !important;
  box-shadow: unset !important;
}
.remove-overflow {
  overflow: hidden;
}
</style>
